import {
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  UseDisclosureReturn,
} from '@chakra-ui/react';
import { AuditLog } from './types';

const RenderNestedFields = ({
  label,
  value,
}: {
  label: string;
  value: object | string;
}) => {
  if (typeof value === 'object' && value !== null)
    return (
      <Flex direction='column'>
        <Text fontWeight='bold' mb={2}>
          {label}
        </Text>
        <Text ml={4}>
          {Object.entries(value).map(([key, value]) => (
            <RenderNestedFields key={key} label={key} value={value} />
          ))}
        </Text>
      </Flex>
    );

  return (
    <Flex direction='row'>
      <Text fontWeight='bold' mb={2}>
        {label}
      </Text>
      <Text mx={2}>:</Text>
      <Text>{value}</Text>
    </Flex>
  );
};

export const AuditLogDetailsModal = ({
  data,
  modalHandler,
}: {
  data: AuditLog;
  modalHandler: UseDisclosureReturn;
}) => {
  const { isOpen, onClose } = modalHandler;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      data-onCloseDrawer='audit-log-details-modal'
      size='2xl'
      autoFocus={false}
    >
      <ModalOverlay />
      <ModalContent data-testid='audit-log-details-modal'>
        <ModalHeader>
          <Heading
            as='h4'
            size='md'
            data-testid='audit-log-details-modal-header'
          >
            Audit Log Details
          </Heading>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <Flex direction='column' gap={6}>
            {Object.entries(data).map(([key, value]) => (
              <RenderNestedFields key={key} label={key} value={value} />
            ))}
          </Flex>
        </ModalBody>
        <ModalFooter justifyContent='flex-end' alignItems='flex-end'>
          <Button
            type='button'
            variant='solid'
            onClick={onClose}
            data-testid='audit-log-details-cancelButton'
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
